{
    "overview__today_sales": "Commandes reçues aujourd'hui",
    "overview__today_margin": "Marge du jour",
    "overview__today_order_count": "Commandes du jour",
    "overview__yesterday": "Hier",
    "section_title__revenue_invoiced": "Total des ventes (facturées)",
    "section_title__margin_invoiced": "Marge brute (facturée)",
    "section_title__margin_order_sum": "Marge brute (commandes reçues)",
    "section_title__order_sum_total": "Total des commandes reçues",
    "chart_label__last_year": "même mois l'an dernier",
    "analysis_section__ai_notice": "Clients recommandés",
    "analysis_section__expansion_potential_title": "🚀 Plus fort potentiel de développement",
    "analysis_section__expansion_potential_subtitle": "Ces clients présentent le plus fort potentiel de développement en valeur absolue",
    "analysis_section__revenue_decline_title": "⚠️ Attrition la plus élevée",
    "analysis_section__revenue_decline_subtitle": "Ces clients présentent les alertes d'attrition les plus élevées en valeur absolue",
    "analysis_section__show_all": "Tout afficher",
    "tab_title_order_overview__open_quotes": "Devis ouverts",
    "tab_title_order_overview__open_orders": "Commandes ouvertes",
    "table_header__sales": "Ventes",
    "overview__filter_billed": "Facturé",
    "activities__tasks_title_one": "Tâche ouverte",
    "activities__tasks_title_many": "Tâches ouvertes",
    "activities__tasks_title_other": "Tâches ouvertes",
    "activities__events_title_one": "Rendez-vous",
    "activities__events_title_many": "Rendez-vous",
    "activities__events_title_other": "Rendez-vous",
    "activities__create_task": "Nouvelle tâche",
    "activities__create_event": "Nouveau rendez-vous",
    "activities__event_title": "Visite client",
    "dashboard__empty_state__title": "Rien de prévu",
    "dashboard__empty_state__subtitle": "<0>Tâche</0> ou <1>Rendez-vous</1> à ajouter",
    "dashboard__empty_state__subtitle_tasks_only": "<0>Tâche</0> à ajouter",
    "analysis_section__snippets__revenue-delta": "{{revenueDelta, number}} de chiffre d'affaires",
    "analysis_section__snippets__order-sum-delta": "{{revenueDelta, number}} de commandes reçues",
    "analysis_section__snippets__days-since-first-order": "{{days}} j depuis la première commande",
    "analysis_section__snippets__days-since-last-order": "{{days}} j depuis la dernière commande",
    "analysis_section__snippets__open_quotes_one": "{{count}} devis ouvert",
    "analysis_section__snippets__open_quotes_many": "{{count}} devis ouverts",
    "analysis_section__snippets__open_quotes_other": "{{count}} devis ouverts",
    "analysis_section__snippets__cross_sell_one": "{{count}}x vente croisée",
    "analysis_section__snippets__cross_sell_many": "{{count}}x vente croisée",
    "analysis_section__snippets__cross_sell_other": "{{count}}x vente croisée",
    "analysis_section__snippets__share_of_wallet_one": "{{count}}x part de portefeuille",
    "analysis_section__snippets__share_of_wallet_many": "{{count}}x part de portefeuille",
    "analysis_section__snippets__share_of_wallet_other": "{{count}}x part de portefeuille",
    "analysis_section__snippets__first_purchase_one": "{{count}}x premier achat",
    "analysis_section__snippets__first_purchase_many": "{{count}}x premier achat",
    "analysis_section__snippets__first_purchase_other": "{{count}}x premier achat",
    "analysis_section__snippets__churn_warning_one": "{{count}}x attrition",
    "analysis_section__snippets__churn_warning_many": "{{count}}x attrition",
    "analysis_section__snippets__churn_warning_other": "{{count}}x attrition",
    "snippet_sales_insights_one": "{{count}} recommandation commerciale",
    "snippet_sales_insights_many": "{{count}} recommandations commerciales",
    "snippet_sales_insights_other": "{{count}} recommandations commerciales",
    "analysis_section__show_dormant_customers": "Afficher les clients en sommeil",
    "chart_tabs__metric_label": "Indicateur"
}
